import React, { useState, useEffect } from 'react';
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import DataTable from 'react-data-table-component';
import { collection, doc, updateDoc, deleteDoc, addDoc, getDocs, query, orderBy } from 'firebase/firestore';
import { auth, db } from "../../firebase";

import "./Teams.css";

const Teams = () => {
  const [teams, setTeams] = useState([]);
  const [name, setName] = useState('');
  const [abr, setAbr] = useState('');
  const [urlLogo, setUrlLogo] = useState('')
  const [order, setOrder] = useState('')
  const [otherCategory, setOtherCategory] = useState(false)
  const [idTeam, setIdTeam] = useState('')

  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  const PAGE_SIZE = 10;

  useEffect(() => {
    const getTeamsFromFirestore = async () => {
      try {
        const teamsCollectionRef = collection(db, 'teams');
        const teamsQuery = query(teamsCollectionRef, orderBy('order'));
        const snapshot = await getDocs(teamsQuery);
        const teamsData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setTeams(teamsData);
      } catch (error) {
        console.error('Error al obtener los datos de los equipos:', error);
      }
    };

    if (!user) return navigate("/")

    getTeamsFromFirestore();
  }, [user,navigate]);

  const columns = [
    {
      name: 'Nombre',
      selector: row => row['name'],
      sortable: true,
    },
    {
      name: 'Abreviatura',
      selector: row => row['abr'],
      sortable: true,
    },
    {
      name: 'Logo',
      cell:(row) => <img height="30em" src={row['url_logo']} alt={row['url_logo']}/>,
      sortable: false,
    },
    {
      cell:(row) => <svg onClick={(e) => handleEditar(e, row)} id={row.ID} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="iconAction"><path d="M1.172,19.119A4,4,0,0,0,0,21.947V24H2.053a4,4,0,0,0,2.828-1.172L18.224,9.485,14.515,5.776Z"/><path d="M23.145.855a2.622,2.622,0,0,0-3.71,0L15.929,4.362l3.709,3.709,3.507-3.506A2.622,2.622,0,0,0,23.145.855Z"/></svg>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      cell:(row) => <svg onClick={(e) => handleEliminar(e, row.id)} id={row.ID} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="iconAction"><path d="m17,4v-2c0-1.103-.897-2-2-2h-6c-1.103,0-2,.897-2,2v2H1v2h1.644l1.703,15.331c.169,1.521,1.451,2.669,2.982,2.669h9.304c1.531,0,2.813-1.147,2.981-2.669l1.703-15.331h1.682v-2h-6Zm-8-2h6v2h-6v-2Zm6.957,14.543l-1.414,1.414-2.543-2.543-2.543,2.543-1.414-1.414,2.543-2.543-2.543-2.543,1.414-1.414,2.543,2.543,2.543-2.543,1.414,1.414-2.543,2.543,2.543,2.543Z"/></svg>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];

  const handleGuardar = async () => {
    
    const nuevoEquipo = {
      name: name,
      abr: abr,
      url_logo: urlLogo,
      otherCategory: otherCategory,
      order: order * 1
    };
    if (idTeam === '') {
      try {
        const docRef = await addDoc(collection(db, 'teams'), nuevoEquipo)
        setTeams([...teams, { id: docRef.id, ...nuevoEquipo }])
        handleLimpiar()
      } catch (error) {
        console.error('Error al agregar el equipo:', error)
      }
    } else {
      const teamToUpdate = teams.filter(itemTeam => itemTeam.id === idTeam)[0]
      if (teamToUpdate.players !== undefined) {
        nuevoEquipo.players = teamToUpdate.players
      }
      try {
        const teamRef = doc(db, 'teams', idTeam)
        await updateDoc(teamRef, nuevoEquipo)
        const nuevosEquipos = [...teams]
        const index = nuevosEquipos.map(e => e.id).indexOf(idTeam)
        nuevoEquipo.id=idTeam
        nuevosEquipos[index] = nuevoEquipo
        setTeams(nuevosEquipos)
        handleLimpiar()
      } catch (error) {
        console.error('Error al modificar el equipo:', error);
      }
    }
  };

  const handleEditar = (event, row) => {
    setName(row.name)
    setAbr(row.abr)
    setUrlLogo(row.url_logo)
    setOtherCategory(row.otherCategory !== undefined?row.otherCategory:false)
    setOrder(row.order * 1)
    setIdTeam(row.id)
  };

  const handleEliminar = async (event, id) => {
    if (window.confirm("Está seguro que desea eliminar el equipo?")) {
      const teamRef = doc(db, 'teams', id)
      await deleteDoc(teamRef)
      const nuevosEquipos = teams.filter(equipo => equipo.id !== id)
      setTeams(nuevosEquipos)
    }
  };

  const handleLimpiar = () => {
    setName('')
    setAbr('')
    setUrlLogo('')
    setOtherCategory(false)
    setOrder('')
    setIdTeam('')
  }

  const handleOtherCategoryChecked = (event) => {
    setOtherCategory(event.target.checked);
  };

  return (
    <div className="container-teams">
      <h2>Equipos</h2>
      
      <h3>Agregar Equipo</h3>
      <input
        type="text"
        placeholder="Nombre"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <input
        type="text"
        placeholder="Abreviatura"
        value={abr}
        onChange={(e) => setAbr(e.target.value)}
      />
      <input
        type="text"
        placeholder="URL del logo"
        value={urlLogo}
        onChange={(e) => setUrlLogo(e.target.value)}
      />
      <input
          type="number"
          placeholder="Orden"
          className="short"
          value={order}
          onChange={(e) => setOrder(e.target.value)}
        />
      <label>Otra categoría</label>
      <input
        type="checkbox"
        checked={otherCategory}
        onChange={handleOtherCategoryChecked}
        />
      <button onClick={handleGuardar}>Guardar</button>
      <button onClick={handleLimpiar}>Limpiar</button>
      <div className="table">
        <DataTable
          columns={columns}
          data={teams}
          pagination
          paginationTotalRows={teams.length}
          paginationPerPage={PAGE_SIZE}
          paginationRowsPerPageOptions={[PAGE_SIZE]}
      />
      </div>
    </div>
  );
};

export default Teams;